export const glossaryData = [
  {
    letter: "A",
    data: [
      {
        name: "Accelerator",
        description:
          "An accelerator is a programme or organisation that helps early-stage startups grow and expand quickly in exchange for equity by offering coaching, cash, and resources.",
      },
      {
        name: "Acquihire",
        description:
          "The term 'acquihire' describes the purchase of a company largely for its superb employees, frequently in the startup ecosystem.",
      },
      {
        name: "Acquisition(business)",
        description:
          "An acquisition is the process by which one firm buys or seizes control of another company, frequently to increase its market presence or product line.",
      },
      {
        name: "Acquisition (customer)",
        description:
          "Customer acquisition is the term used to describe the methods and actions a company use to attract new customers and grow its client base.",
      },
      {
        name: "Angel Investor",
        description:
          "An angel investor is a person who lends money to early-stage firms in exchange for equity ownership, frequently providing coaching and experience in addition to finance.",
      },
      {
        name: "Annual Recurring Revenue (ARR)",
        description:
          "Annual Recurring Revenue (ARR) is a crucial indicator for subscription-based firms since it shows the entire annual revenue from ongoing customer contracts or subscriptions.",
      },
      {
        name: "Anti-dilution Clause",
        description:
          "An anti-dilution clause safeguards investors from equity dilution by modifying their ownership interest if the company issues more shares at a lower valuation than the initial investment.",
      },
      {
        name: "Attribution",
        description:
          "The term 'attribution' often refers to the process of determining and assessing the influence of various marketing channels and campaigns on user acquisition and revenue generation.",
      },
      {
        name: "Attrition",
        description:
          "Attrition is the gradual loss of customers or staff over time, frequently as a result of churn, natural turnover, or other circumstances.",
      },

    ],
  },
  {
    letter: "B",
    data: [
      {
        name: "BHAG",
        description:
          "BHAG, which stands for 'Big Hairy Audacious Goal,' is a word frequently used in the startup community to indicate a very long-range, highly ambitious aim that inspires and encourages a company's stakeholders.",
      },
      {
        name: "Bootstrapping",
        description:
          "In the startup environment, 'bootstrapping' is the process of establishing and expanding a business without the help of outside capital and therefore depending on internal revenue and resources to achieve long-term success.",
      },
      {
        name: "Bubble",
        description:
          "In the context of startups, a 'bubble' is often defined as a time of excessive market speculation and overvaluation during which the values of startup investments or assets diverge from their intrinsic value, potentially presaging a downturn or collapse.",
      },
      {
        name: "Burn Rate",
        description:
          "Burn rate, which is commonly calculated on a monthly basis, is the rate at which a startup or company is using its capital or funds to cover operating expenses.",
      },
      {
        name: "Business Model",
        description:
          "A business model defines how a company creates, delivers, and captures value. It includes revenue sources, customer segments, and distribution channels.",
      },
      {
        name: "Burn Rate",
        description:
          "Burn rate represents the rate at which a company is spending its capital or funds. It is often used to assess financial sustainability.",
      },
    ],
  },
  {
    letter: "C",
    data: [
      {
        name: "Cap Table",
        description:
          "The term 'cap table,' which stands for 'capitalization table,' refers to a document that describes the ownership structure of a business, including the equity stakes held by founders, investors, and other stakeholders. It frequently includes details on various share classes and their relative ownership percentages.",
      },
      {
        name: "Capital",
        description:
          "Capital refers to the financial resources, often in the form of cash or assets, that a company employs to fund its operations, invest in growth, and accomplish its business objectives.",
      },
      {
        name: "Carried Interest",
        description:
          "Carried interest, also shortened to 'carry,' is a portion of profits that venture capitalists or private equity investors receive in exchange for running and expanding an investment fund. Usually, it represents a portion of the returns on successful investments made by the fund.",
      },
      {
        name: "Churn Rate",
        description:
          "Churn rate, which is frequently measured monthly or annually, is the proportion of consumers or subscribers who discontinue using a service, cancel a subscription, or stop being engaged with a product during a given period.",
      },
      {
        name: "Cliff",
        description:
          "A 'cliff' in startup equity is the amount of time an employee or founder must work for the business before being qualified for stock options or equity grants.",
      },
      {
        name: "CMO (Chief Marketing Officer)",
        description:
          "A CMO, or chief marketing officer, is a senior executive in responsible for managing a company's branding, marketing, and promotional initiatives in order to increase client base and income.",
      },
      {
        name: "Content Marketing",
        description:
          "A method known as 'content marketing' focuses on creating and distributing worthwhile, pertinent, and consistent content to draw in and engage a target audience with the intention of fostering brand awareness and trust and, ultimately, encouraging profitable consumer actions.",
      },
      {
        name: "Conversion Rate Optimisation (CRO)",
        description:
          "Conversion rate optimisation (CRO) is the process of methodically enhancing a website, app, or marketing campaign to raise the proportion of users who complete desired actions, such as completing a purchase, signing up, or filling out a form.",
      },
      {
        name: "Convertible Note",
        description:
          "A convertible note is a kind of short-term loan instrument used to finance startups; it normally has a fixed interest rate and a maturity date. It may change into equity (ownership) in the business at a later date, typically when the firm receives a subsequent round of funding.",
      },
      {
        name: "Cottage Business / Lifestyle Business",
        description:
          "A cottage business, also known as a lifestyle business, is a small-scale entrepreneurial attempt that is often conducted by one or more people, frequently from their homes, and whose main objective is to sustain a pleasant lifestyle rather than pursuing large development or rapid growth.",
      },
      {
        name: "CPO (Chief Product Officer)",
        description:
          "A chief product officer (CPO) is the executive in charge of a company's strategic product initiatives. They direct the whole course of a brand's product, including features and how to express them.",
      },
      {
        name: "Crowdfunding",
        description:
          "Crowdfunding	Crowdfunding is a technique for obtaining small investments or contributions from a large number of people, generally through online platforms or social media, in exchange for rewards, equity, or other incentives.",
      },
      {
        name: "Crowdsourcing",
        description:
          "Crowdsourcing is the practise of collecting ideas, services, material, or solutions by asking for contributions from a sizable and frequently varied group of people, usually through online platforms, in order to tap into the collective wisdom and creativity of the crowd.",
      },

      {
        name: "CTO (Chief Technology Officer)",
        description:
          "A CTO, or chief technology officer, is a senior executive in charge of managing a company's technological strategy, innovation, and development activities, with a focus on coordinating technological endeavours with organisational objectives.",
      },
      {
        name: "Customer Acquisition Cost (CAC)",
        description:
          "Customer Acquisition Cost (CAC) is the overall cost incurred by a business to acquire a new customer. It is commonly determined by dividing all marketing and sales expenses by the number of new customers acquired during a given time period.",
      },
      {
        name: "Customer Relationship Management (CRM)",
        description:
          "CRM is a tool and approach used by organisations to track and manage communications with both current and potential clients. In order to increase sales, marketing, and customer service, it frequently entails using software tools and techniques to track interactions, optimise customer communication, and strengthen connections.",
      },

    ],
  },

  {
    letter: "D",
    data: [
      {
        name: "Data room",
        description:
          "A data room, sometimes referred to as a virtual data room, is an online information database used for document storage and sharing. typically used to store records related to investment round due diligence.",
      },
      {
        name: "Debt Capital",
        description:
          "Debt capital is the term used to describe money that a business raises through borrowing, usually in the form of loans or bonds that must be repaid with interest over a set period of time. In contrast to equity financing, it allows businesses to raise money without giving up ownership interests.",
      },
      {
        name: "Dilution",
        description:
          "the decrease in existing shareholders' ownership stake when a business issues new shares, frequently during fundraising rounds.",
      },
      {
        name: "Down Round",
        description:
          "When a firm receives money at a lower valuation than its prior investment round, it is known as a 'down round' and can indicate financial difficulties or a drop in the company's perceived worth.",
      },
      {
        name: "Drag-Along Rights / Drag-Along Clause",
        description:
          "Drag-Along Clauses, often referred to as Drag-Along Rights, are clauses in a startup's shareholder agreement that permit majority shareholders to compel minority shareholders to participate in the sale of the company, assuring a unified sale process.",
      },
      {
        name: "Due Dilligence",
        description:
          "The process used by investors to determine whether a potential investment is viable and to confirm the accuracy of the startup's information.",
      },

    ],
  },

  {
    letter: "E",
    data: [
      {
        name: "Elevator pitch",
        description:
          "a brief description of your company's operations.",
      },
      {
        name: "Enterprise Investment Scheme (EIS)",
        description:
          "The UK government's Enterprise Investment Scheme (EIS) assists younger, riskier businesses in raising capital by providing considerable tax breaks to investors. ",
      },
      {
        name: "Equity",
        description:
          "equity is used to describe ownership shares or ownership interests in the firm, which are sometimes expressed as stocks or shares and reflect a claim on the company's assets and earnings.",
      },
      {
        name: "Equity Capital",
        description:
          "Equity capital is funding for a startup or firm that is raised without the use of debt by giving investors ownership stakes in the company in exchange for their investments.",
      },
      {
        name: "Equity Crowdfunding",
        description:
          "Equity crowdfunding is the practise of raising money by collecting small investments from a large number of individuals in exchange for a tiny percentage of equity, typically through a third-party platform.",
      },
      {
        name: "Exit Strategy",
        description:
          "In the startup business, an exit strategy is a prearranged plan for how investors and founders want to get their money back or realise their investments, frequently through choices like merger, IPO (Initial Public Offering), or acquisition.",
      },

    ],
  },

  {
    letter: "F",
    data: [
      {
        name: "Founder",
        description:
          "A founder is a person or group of people who create and launch a startup or business. They are frequently in charge of the venture's initial conception, conception, and early development.",
      },
      {
        name: "Fundraising",
        description:
          "Fundraising	The process of raising money by exchanging equity for outside investment is referred to as fundraising; it can also refer to alternate methods of acquiring money, such debt finance or crowdfunding. ",
      },
    ],
  },


  {
    letter: "G",
    data: [
      {
        name: "Gamification",
        description:
          "A startup can use gamification to add a game-layer to a product or service that motivates customers to execute a particular action in exchange for a reward.",
      },
      {
        name: "Go-to-market Strategy (GTM)",
        description:
          "A go-to-market strategy (GTM) is a detailed plan created to successfully introduce a good or service to the market.",
      },


      {
        name: "Growth Hacking",
        description:
          "Growth hacking is a type of startup marketing that focuses on quick and inexpensive ways to attract and keep customers, frequently using innovative and data-driven strategies to accelerate growth.",
      },
    ],
  },

  {
    letter: "H",
    data: [
      {
        name: "Hockey Stick",
        description:
          "A 'hockey stick' growth curve is a quick, sudden rise in a company's growth or revenue following a period of relatively modest progress that resembles the shape of a hockey stick.",
      },
    ],
  },


  {
    letter: "I",
    data: [
      {
        name: "Incubator",
        description:
          "An incubator is a company or programme that helps early-stage entrepreneurs grow and succeed by offering them resources, mentoring, and assistance, frequently in exchange for ownership or a part in the business.",
      },
      {
        name: "Investment Syndicate",
        description:
          "An investing syndicate is a group of individual investors or venture capital firms who pool their funds and resources to make a number of startup investments.",
      },


      {
        name: "Growth Hacking",
        description:
          "Growth hacking is a type of startup marketing that focuses on quick and inexpensive ways to attract and keep customers, frequently using innovative and data-driven strategies to accelerate growth.",
      },
    ],
  },

  {
    letter: "L",
    data: [
      {
        name: "Landing Page",
        description:
          "A landing page is a single web page created for a particular marketing or promotional campaign. Its primary goal is to persuade visitors to do a certain action, such as downloading an ebook, signing up for a newsletter, or making a purchase.",
      },
      {
        name: "Lead Investor",
        description:
          "A lead investor in a round of startup fundraising is often the first individual or venture capital firm to commit to making a sizeable investment. They frequently decide on the investment's terms and conditions and are essential in luring further investors into the round.",
      },


      {
        name: "Lean Startup",
        description:
          "A process used when starting a new firm or releasing a new product to swiftly and affordably validate a business proposition.",
      },
      {
        name: "Lifetime Value (LTV)",
        description:
          "Lifetime Value (LTV), which is frequently used to evaluate the long-term value of attracting and maintaining consumers, is a metric that measures the total revenue a business can expect to generate from a single customer or user throughout the course of their relationship with the organisation.",
      },
      {
        name: "Lean Canvas",
        description:
          "A Lean Canvas, which functions similarly to a business plan, is a one-page visual tool that assists companies in quickly outlining their essential business elements, such as problem, solution, target market, and income streams.",
      },
    ],
  },

  {
    letter: "M",
    data: [
      {
        name: "Market Penetration (Market Share)",
        description:
          "The percentage of a total market that your startup will win as customers, within a given timefame.",
      },
      {
        name: "Marketing Automation",
        description:
          "The process of employing software to automate marketing tasks is known as marketing automation.",
      },


      {
        name: "Marketing Dashboard / Marketing Intelligence Dashboard",
        description:
          "A marketing dashboard, also known as a marketing intelligence dashboard, is a visual display or software tool that offers insights and data on various marketing metrics and key performance indicators (KPIs) periodically or in real-time. It assists businesses in tracking and analysing their marketing activities and in making strategic decisions.",
      },
      {
        name: "Media Spend",
        description:
          "The term 'media spend' is the amount of money that a business allots or invests in several forms of advertising and marketing, such as television, digital advertising, print media, or social media, to market its goods and services.",
      },
      {
        name: "Minimum Viable Product (MVP)",
        description:
          "Minimum Viable Product (MVP)	A minimum viable product (MVP) is an early customer-usable version of a product that is used to test a business or product concept. These clients subsequently offer comments for upcoming product development.",
      },

      {
        name: "Moat (Economic Moat)",
        description:
          "Any competitive advantage a company has over competitors that renders the business model 'defensible' is known as an economic moat.",
      },
      {
        name: "Monthly Recurring Revenue (MRR)",
        description:
          "Monthly recurring revenue is regular money that a company gets every month.",
      },

      {
        name: "Monetization",
        description:
          "The process of earning money from a startup's good or service is known as monetization.",
      },
    ],
  },

  {
    letter: "P",
    data: [
      {
        name: "Pay-per-click (PPC)",
        description:
          "In the pay-per-click (PPC) model of internet advertising, advertisers are charged a fee each time a user clicks one of their ads. To direct visitors to a website or landing page, it is frequently used in search engine advertising, display advertising, and social media advertising.",
      },
      {
        name: "Pitch Deck",
        description:
          "Pitch Deck	Startups generally use a pitch deck, a succinct and aesthetically appealing presentation, to explain their business concept, value proposition, market opportunity, and financial projections to potential investors or stakeholders.",
      },


      {
        name: "Pivot",
        description:
          "The process of turning a bad product or service into a successful one using expertise and available resources.",
      },
      {
        name: "Portfolio Company",
        description:
          "A company that has obtained funding from a VC fund or an angel investor becomes one of the fund's or investor's portfolio companies.",
      },
      {
        name: "Post-money Valuation",
        description:
          "Post-money valuation refers to the projected value of a startup or company following the addition of outside funds and finance, such as contributions from investors or venture capitalists, to the balance sheet of the business. It displays the firm's valuation right after the investment round.",
      },

      {
        name: "Pre-money Valuation",
        description:
          "Pre-money valuation describes the worth of a startup excluding outside investment or funding. The value of a startup before receiving any funding.",
      },


      {
        name: "Pre-Seed Round",
        description:
          "Pre-seed rounds are the first round of fundraising for businesses, during which the founders look for an insignificant amount of money, frequently from family and friends or angel investors, to develop an idea, build a prototype, or conduct preliminary market research before pursuing larger investment rounds.",
      },


      {
        name: "Private Equity (PE)",
        description:
          "Private equity consists of capital that is invested directly in private businesses and is not listed on a public exchange.",
      },
      {
        name: "Product Led Growth (PLG)",
        description:
          "Product Led Growth (PLG)	Product-Led Growth (PLG) is a business approach in which the product itself serves as the main engine for gaining, keeping, and growing a customer base. In PLG, the product is made to be simple to use, self-serve, and easy to adopt. This enables users to rapidly see its value and frequently results in viral growth.",
      },
      {
        name: "Product Manager",
        description:
          "A product manager is someone who defines the product vision, leads the team developing the product, and typically recognises the consumer demand and bigger business objectives that a product or feature will meet.",
      },
      {
        name: "Product Marketing",
        description:
          "Product Marketing	A company's product marketing department is responsible for promoting and positioning a product or service to its target market. In addition to performing market research to understand consumer demands and competition, it entails developing marketing strategies, messaging, and campaigns to communicate the product's value, features, and benefits.",
      },


      {
        name: "Product Roadmap",
        description:
          "A product roadmap is a high-level visual overview that depicts the vision and direction of your product offering, typically focused on features and the advantages for users.",
      },

      {
        name: "Proof of concept",
        description:
          "A sample or prototype of a good or service to demonstrate its viability.",
      },

    ],
  },

  {
    letter: "R",
    data: [
      {
        name: "Referral Marketing",
        description:
          "Referral marketing is a sales strategy that uses word-of-mouth and referrals to expand the customer base of a business through the networks of its current customers.",
      },
      {
        name: "Run Rate",
        description:
          "Run rate is the extrapolation of current financial performance over a predetermined time frame, usually one year. Based on the most recent information available, it is used to predict future income, expenses, or other financial variables.",
      },

      {
        name: "Runway",
        description:
          "Monthly or weekly rate at which a business uses cash on reserve to cover expenses.",
      },

    ],
  },

  {
    letter: "S",
    data: [
      {
        name: "Scalable",
        description:
          "The term 'scalable' is used to describe a company model or technology that can effectively handle expansion and rising demand without proportionately increasing costs or resources. It suggests the capacity to enhance operations or services without a linear rise in costs.",
      },
      {
        name: "Scale-up",
        description:
          "Scale-up is the typical term used to describe a startup as it enters the growth phase.",
      },

      {
        name: "Search Engine Optimisation (SEO)",
        description:
          "The act of enhancing a website so that it will appear more prominently in search results for relevant search terms, typically with a focus on user experience, crawlability, indexability, and content relevancy.",
      },


      {
        name: "Seed Enterprise Investment Scheme (SEIS)",
        description:
          "The UK government established SEIS, a tax relief programme, to promote investment in startups and early-stage companies.",
      },
      {
        name: "Seed Funding",
        description:
          "Seed financing, which is frequently obtained through angel investors, venture capitalists, or incubators, is the initial capital raised by a startup to develop its product, do market research, and get ready for additional investment rounds.",
      },
      {
        name: "Series A",
        description:
          "Series A	In the Series A investment round, a startup that has successfully completed the seed stage receives sizeable funding from venture capitalists to further develop its product, broaden its market reach, and scale the business.",
      },

      {
        name: "Shareholders' Agreement",
        description:
          "A shareholders' agreement, which is a legally binding agreement defining the rights, obligations, and regulations regulating the administration and ownership of a company among its shareholders, is frequently used in startups to safeguard interests and settle disagreements.",
      },
      {
        name: "Software-as-a-Service (SaaS)",
        description:
          "Software as a Service (SaaS) is a model for licencing and delivering software in which the software is centrally hosted, typically via the cloud.",
      },
      {
        name: "Stack (Tech or Marketing)",
        description:
          "Stack (Tech or Marketing)	Originally used to refer to all the technical services required to create and maintain a single application, the term is now more broadly used to refer to a group of technologies and tools a company uses to carry out a specific role.",
      },
      {
        name: "Startup",
        description:
          "Startups are new businesses that are still in their early phases of operation and are typically characterised by high costs and little to no revenue (financed either by the founders themselves or external investment).",
      },
      {
        name: "Stealth mode",
        description:
          "In the startup environment, the phrase 'stealth mode' is used to describe the state in which a business operates in secrecy, keeping its product, technology, or plans secret to maintain a competitive advantage until it's ready to divulge them to the general public or investors.",
      },

      {
        name: "Sweat Equity",
        description:
          "Awarding shares/equity in a startup to early employees or contractors in place of some (or all) of their salary.",
      },
    ],
  },

  {
    letter: "T",
    data: [
      {
        name: "Target Company",
        description:
          "Target Company	A startup that a VC or angel investor is considering investing in.",
      },
      {
        name: "Term Sheet",
        description:
          "Term sheets are non-binding contracts that outline the fundamental terms and conditions of an investment.",
      },

      {
        name: "Total Addressable Market (TAM)",
        description:
          "Total Addressable Market (TAM) is the collective income potential for a given good or service in a certain market or industry, assuming ideal market circumstances and no competition restrictions.",
      },
      {
        name: "Traction",
        description:
          "The evidence that customers are willing to pay for your product or service. Progress or early growth is exhibited by traction.",
      },

    ],
  },

  {
    letter: "U",
    data: [
      {
        name: "Unicorn",
        description:
          "A privately owned company with a valuation of $1 billion or more is referred to as a 'unicorn' in the startup sector. This achievement is often the result of the company seeing rapid development, having a substantial market presence, and having investors who believe in its potential.",
      },

      {
        name: "Unicorn Exit",
        description:
          "A unicorn exit is when a startup successfully exits after reaching a valuation of $1 billion or more, either through an acquisition or an initial public offering (IPO).",
      },

    ],
  },



  {
    letter: "V",
    data: [
      {
        name: "Valuation",
        description:
          "The calculation of what the startup is worth.",
      },
      {
        name: "VC (Venture Capitalist)",
        description:
          "A venture capitalist (VC) is a type of private equity investor who lends money to businesses with strong development potential in return for an equity ownership.",
      },

      {
        name: "Vesting (Schedule)",
        description:
          "The period of time that founders and employees must work for the business before getting their full ownership stake.",
      },
      {
        name: "Traction",
        description:
          "The evidence that customers are willing to pay for your product or service. Progress or early growth is exhibited by traction.",
      },

    ],
  },

  {
    letter: "W",
    data: [
      {
        name: "Wireframe",
        description:
          "A wireframe is a simple, two-dimensional visual depiction of the layout of a web page, app interface, or product.",
      },

    ],
  },
];
